<template>
  <SearchInput
    :value="state"
    :placeholder="'placeholder'"
  />
</template>

<script>
export default {
  data() {
    return {
      state: ""
    }
  }
}
</script>